import React from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import IconRadiusButton from './IconRadiusButton';
import { useTheme } from '@material-ui/core';
import ic_delete from '../assets/icons/Trash-black.png'


export default function ArrowRightButton({ bgColor, border, ...props }) {
    const theme = useTheme()
    return (
        <IconRadiusButton bgColor={bgColor || 'white'} borderRadius='6px' border={border || `solid 1px ${theme.palette.secondary.main}`} {...props}>
            <img src={ic_delete} width={16} height={16} />
        </IconRadiusButton>
    );
}
